// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + {"440":"datadogProfiler","581":"datadogRecorder"}[chunkId] + "." + {"440":"02e6fe11","581":"52e7c25b"}[chunkId] + ".chunk.js");